import AppHeaders from '@/helpers/operations/AppHeaders'

type HeadersModule = typeof import('next/headers')

async function getAdditionalContext() {
  if (typeof window === 'undefined' && typeof require !== 'undefined') {
     
    const headers = await ((await import('next/headers')) as HeadersModule).headers()
    const referer = headers.get(AppHeaders.Referer)
    return { referer }
  }
  return {}
}
export default getAdditionalContext
